import { render, staticRenderFns } from "./wtr-cascade-selection.vue?vue&type=template&id=05c135e2&scoped=true&"
import script from "./wtr-cascade-selection.vue?vue&type=script&lang=js&"
export * from "./wtr-cascade-selection.vue?vue&type=script&lang=js&"
import style0 from "./wtr-cascade-selection.vue?vue&type=style&index=0&id=05c135e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c135e2",
  null
  
)

export default component.exports